import { Heart, ShoppingBag } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { addToCart } from "../lib/cart";
import { Currency, formatMoney } from "../lib/currency";

export type Product = { id: number; slug: string; title: string; price: number; compare_at_price?: number; image?: string; category?: string; rating?: number };

export default function ProductCard({ product, currency }: { product: Product; currency: Currency }) {
  const { lang = "en" } = useParams();
  return (
    <article className="group overflow-hidden rounded-lg bg-white shadow-soft transition hover:-translate-y-1">
      <Link to={`/${lang}/products/${product.slug}`} className="block aspect-[4/5] bg-slate-100">
        <img src={product.image || "/placeholder.webp"} alt={product.title} className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
      </Link>
      <div className="space-y-3 p-4">
        <div>
          <p className="text-xs uppercase tracking-wide text-teal">{product.category || "Featured"}</p>
          <Link to={`/${lang}/products/${product.slug}`} className="mt-1 line-clamp-2 font-semibold text-ink">{product.title}</Link>
        </div>
        <div className="flex items-center justify-between">
          <div><span className="font-bold">{formatMoney(product.price, currency)}</span> {product.compare_at_price && <span className="text-sm text-slate-400 line-through">{formatMoney(product.compare_at_price, currency)}</span>}</div>
          <div className="flex gap-2">
            <button className="rounded-md border border-slate-200 p-2 hover:text-coral" aria-label="Wishlist"><Heart size={18} /></button>
            <button className="rounded-md bg-ink p-2 text-white hover:bg-coral" aria-label="Add to cart" onClick={() => addToCart({ productId: product.id, slug: product.slug, title: product.title, image: product.image, price: product.price, quantity: 1 })}><ShoppingBag size={18} /></button>
          </div>
        </div>
      </div>
    </article>
  );
}
